import React from 'react';
import { func, string, array, number, object, bool } from 'prop-types';
import numeral from 'numeral';
import Radium from 'radium';
import { UTButton, UTLabel, WithLoading } from '@widergy/energy-ui';
import { connect } from 'react-redux';
import { getIn } from 'seamless-immutable';

import { ROUTES } from 'constants/routes';

import AccountDebtTable from '../AccountDebtTable';
import { historyColumns, accountDebtColumns } from '../AccountDebtTable/constants';
import {
  getAccountDueConcepts,
  getProcedureHistory,
  getConceptsByAmount
} from '../../accountHolderChangeHelper';
import { message } from '../../../../../../../utils/stringUtils';

import styles from './styles';

function AccountHolderChangeHistory({
  clientNumber,
  bills,
  currentAccountHolderName,
  accountTotalDebt,
  accountDueDebt,
  onProcedureCancel,
  onPayment,
  processHistory,
  showOnlyHistory,
  formType,
  location
}) {
  return (
    <div style={styles.container}>
      {processHistory && (
        <div style={styles.title}>
          <UTLabel bold large>
            {formType}
          </UTLabel>
          <UTLabel bold large>{` Tramite Nº ${processHistory.Id}`}</UTLabel>
          <UTLabel bold large>
            {processHistory &&
              processHistory.ProcessActivity &&
              processHistory.ProcessActivity.State &&
              processHistory.ProcessActivity.State.Title}
          </UTLabel>
        </div>
      )}
      {!showOnlyHistory && (
        <React.Fragment>
          <div style={styles.defaultStylesTable}>
            <AccountDebtTable
              title={message('AccountHolderChange:clientDebt', { supply: clientNumber })}
              concepts={getConceptsByAmount(
                bills.DeudaSuministro,
                bills.DepositoEnGarantia,
                bills.DeudaRemanente
              )}
              tableColumns={accountDebtColumns}
            />
            <div style={currentAccountHolderName && styles.table}>
              {currentAccountHolderName && (
                <AccountDebtTable
                  title={message('AccountHolderChange:ownDebt', {
                    holder: currentAccountHolderName
                  })}
                  concepts={getAccountDueConcepts(bills.DeudaCliente)}
                  tableColumns={accountDebtColumns}
                />
              )}
            </div>
          </div>
          <div style={styles.totalDebt}>
            <UTLabel extrabold>
              {message('AccountHolderChange:userDebt', {
                debt: numeral(accountTotalDebt + accountDueDebt).format('$ 0.[00]')
              })}
            </UTLabel>
          </div>

          <div style={styles.debtDescContainer}>
            <UTLabel>
              {location === ROUTES.NEW_TERMINATION_REQUEST
                ? message('AccountHolderChange:debtDescriptionNisBelongingUser')
                : message('AccountHolderChange:accountDebtDescription')}
            </UTLabel>
          </div>

          <div style={styles.buttonsContainer}>
            <UTButton secondary style={styles.button} onPress={onProcedureCancel}>
              {message('AccountHolderChange:cancel')}
            </UTButton>
            <UTButton onPress={onPayment}>{message('AccountHolderChange:payDebt')}</UTButton>
          </div>
        </React.Fragment>
      )}

      <div style={styles.defaultStylesTable}>
        <AccountDebtTable
          title={message('AccountHolderChange:procedureHistory')}
          concepts={getProcedureHistory(processHistory)}
          tableColumns={historyColumns}
        />
      </div>
    </div>
  );
}

AccountHolderChangeHistory.propTypes = {
  clientNumber: string,
  bills: array, // eslint-disable-line
  currentAccountHolderName: string,
  accountTotalDebt: number,
  accountDueDebt: number,
  onProcedureCancel: func,
  onPayment: func,
  showOnlyHistory: bool,
  formType: string,
  processHistory: object, // eslint-disable-line
  location: string
};

const mapStateToProps = store => ({
  location: getIn(store, ['router', 'location', 'pathname'])
});

export default connect(mapStateToProps)(
  WithLoading(props => props.loading)(Radium(AccountHolderChangeHistory))
);
